const getVersionHistoryUrl = (keyId) => `/api/v1/bg/vault/secrets/versions/${keyId}`;

export default getVersionHistoryUrl;